import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { HeaderService } from './header.service';
import { StorageService } from './storage.service';
import * as i0 from "@angular/core";
import * as i1 from "./storage.service";
import * as i2 from "./api.service";
import * as i3 from "@ngx-translate/core";
import * as i4 from "./header.service";
var PreferitiService = /** @class */ (function () {
    function PreferitiService(storage, apiService, translate, header) {
        this.storage = storage;
        this.apiService = apiService;
        this.translate = translate;
        this.header = header;
    }
    PreferitiService.prototype.getPreferiti = function () {
        if (this.storage.isBrowser) {
            var preferitiInSessione = this.storage.getLocal('preferiti-stem');
            return preferitiInSessione ? of(preferitiInSessione) : this.aggiornaPreferiti();
        }
        else {
            return of([]);
        }
    };
    PreferitiService.prototype.aggiornaPreferiti = function () {
        var _this = this;
        var language = this.translate.currentLang.toUpperCase();
        return this.apiService.utenteRegistratoGetWishlist({ language: language, tipoOggetto: 'SCHEDA' }).pipe(map(function (res) {
            if (res && res.preferiti) {
                _this.storage.setLocal('preferiti-stem', res.preferiti);
                _this.header.aggiornaPreferiti.emit();
                return res.preferiti;
            }
        }));
    };
    PreferitiService.prototype.salvaPreferito = function (prodotto) {
        var _this = this;
        var language = this.translate.currentLang.toUpperCase();
        return this.apiService.utenteRegistratoSavePreferito({ language: language, tipoOggetto: 'SCHEDA', idElemento: prodotto.id || prodotto.idScheda }).pipe(switchMap(function () { return _this.aggiornaPreferiti(); }));
    };
    PreferitiService.prototype.deletePreferito = function (prodotto) {
        var _this = this;
        var language = this.translate.currentLang.toUpperCase();
        return this.apiService.utenteRegistratoDeletePreferito({ language: language, tipoOggetto: 'SCHEDA', idElemento: prodotto.id || prodotto.idScheda }).pipe(switchMap(function () { return _this.aggiornaPreferiti(); }));
    };
    /** @nocollapse */ PreferitiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PreferitiService_Factory() { return new PreferitiService(i0.ɵɵinject(i1.StorageService), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i4.HeaderService)); }, token: PreferitiService, providedIn: "root" });
    return PreferitiService;
}());
export { PreferitiService };
